import React from 'react'
import './PageTitle.sass'
import { useContext } from 'react'
import { AuthContext } from '../../App'

function PageTitle() {
  const { pageTitle } = useContext(AuthContext)

  return (
    <div className="PageTitle">
      <p className="Title">{pageTitle}</p>
    </div>
  )
}

export default PageTitle
